import { t } from 'ember-intl';
import { BreadcrumbsItem } from 'core/components';

<template>
  <BreadcrumbsItem
    @route="terraform.workspaces.list"
    @text={{t "components.page.terraform.workspaces.list.title"}}
  />

  {{outlet}}
</template>
